function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { forwardRef } from 'react';
import * as PopoverPrimitive from '@radix-ui/react-popover';
import { ReactComponent as PopoverArrow } from 'assets/icons/popover_arrow.svg';
import * as S from './Popover.styles';
export const Popover = ({
  children,
  defaultOpen,
  open,
  onOpenChange = () => {}
}) => {
  return /*#__PURE__*/React.createElement(PopoverPrimitive.Root, {
    defaultOpen: defaultOpen,
    open: open,
    onOpenChange: onOpenChange
  }, children);
};
export const PopoverTrigger = /*#__PURE__*/forwardRef(({
  children,
  asChild = true
}, forwardedRef) => {
  return /*#__PURE__*/React.createElement(PopoverPrimitive.Trigger, {
    asChild: asChild,
    ref: forwardedRef
  }, children);
});
export const PopoverContent = /*#__PURE__*/forwardRef(({
  arrow = true,
  avoidCollisions = false,
  children,
  className,
  hasPadding = true,
  id,
  onCloseAutoFocus,
  onEscapeKeyDown,
  onInteractOutside,
  onOpenAutoFocus,
  portalContainer,
  sideOffset = 0,
  maxHeight,
  width = 210,
  scrollable,
  ...contentProps
}, forwardedRef) => {
  const handleCloseAutoFocus = event => {
    return onCloseAutoFocus ? onCloseAutoFocus(event) : {};
  };
  const handleEscapeKeyDown = event => {
    return onEscapeKeyDown ? onEscapeKeyDown(event) : {};
  };
  const handleInteractOutside = event => {
    return onInteractOutside ? onInteractOutside(event) : {};
  };
  const handleOpenAutoFocus = event => {
    return onOpenAutoFocus ? onOpenAutoFocus(event) : {};
  };
  return /*#__PURE__*/React.createElement(PopoverPrimitive.Portal, {
    container: portalContainer
  }, /*#__PURE__*/React.createElement(S.PopoverContent, _extends({
    align: "start",
    avoidCollisions: avoidCollisions,
    className: className,
    $hasPadding: hasPadding,
    id: id,
    onCloseAutoFocus: handleCloseAutoFocus,
    onEscapeKeyDown: handleEscapeKeyDown,
    onInteractOutside: handleInteractOutside,
    onOpenAutoFocus: handleOpenAutoFocus,
    sideOffset: sideOffset,
    $maxHeight: maxHeight,
    $width: width,
    $scrollable: scrollable,
    ref: forwardedRef
  }, contentProps), children, arrow ? /*#__PURE__*/React.createElement(S.PopoverArrow, {
    asChild: true
  }, /*#__PURE__*/React.createElement(S.ArrowContainer, null, /*#__PURE__*/React.createElement(PopoverArrow, null))) : null));
});
export const PopoverClose = /*#__PURE__*/forwardRef(({
  children,
  asChild = true
}, forwardedRef) => {
  return /*#__PURE__*/React.createElement(PopoverPrimitive.Close, {
    asChild: asChild,
    ref: forwardedRef
  }, children);
});